
(function () {
  'use strict';

  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.state === 'loaded') return;

      if (this.querySelector('[data-related-content]')) {
        this.dataset.state = 'loaded';
        this.initCarousel();
        return;
      }

      var self = this;
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            self._observer.disconnect();
            self._observer = null;
            self.loadRecommendations();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this._observer.observe(this);
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._controller) this._controller.abort();
      this.destroyCarousel();
    }

    loadRecommendations() {
      if (this.dataset.state === 'loading' || this.dataset.state === 'loaded') return;
      this.dataset.state = 'loading';

      if (this._controller) this._controller.abort();
      this._controller = new AbortController();

      var self = this;
      fetch(this.dataset.url, { signal: this._controller.signal })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-related-content]');
          self.dataset.state = 'loaded';
          if (content) {
            self.innerHTML = content.outerHTML;
            self.activateScripts();
            self.hidden = false;
            self.initCarousel();
          } else {
            self.handleEmpty();
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          self.dataset.state = 'loaded';
          self.handleEmpty();
        });
    }

    activateScripts() {
      this.querySelectorAll('script[src]').forEach(function (inert) {
        var fresh = document.createElement('script');
        fresh.src = inert.src;
        if (inert.defer) fresh.defer = true;
        inert.replaceWith(fresh);
      });
    }

    initCarousel(attempts) {
      if (window.SectionCarousel) window.SectionCarousel.initIn(this);

      var el = this.querySelector('[data-related-swiper]');
      if (!el || el.swiperInstance) return;

      if (!window.Swiper) {
        attempts = attempts || 0;
        if (attempts >= 40 || !this.isConnected) return;
        var self = this;
        setTimeout(function () {
          self.initCarousel(attempts + 1);
        }, 100);
        return;
      }

      var colsDesktop = parseInt(el.dataset.colsDesktop, 10) || 4;
      var colsLaptop = parseInt(el.dataset.colsLaptop, 10) || 3;
      var colsTablet = parseInt(el.dataset.colsTablet, 10) || 2;
      var colsMobile = parseInt(el.dataset.colsMobile, 10) || 1;

      var gap = parseInt(el.dataset.gap, 10) || 16;
      var navStyle = el.dataset.nav || 'navigation';

      var opts = {
        slidesPerView: colsMobile,
        spaceBetween: gap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        a11y: { slideRole: 'listitem' },
        breakpoints: {
          0: {
            slidesPerView: colsMobile,
            spaceBetween: gap
          },

          576: {
            slidesPerView: colsTablet,
            spaceBetween: gap
          },

          992: {
            slidesPerView: colsLaptop,
            spaceBetween: gap
          },

          1200: {
            slidesPerView: colsDesktop,
            spaceBetween: gap
          }
        }
      };

      if (navStyle === 'navigation' || navStyle === 'both') {
        opts.navigation = {
          nextEl: el.querySelector(':scope > .swiper-button-next'),
          prevEl: el.querySelector(':scope > .swiper-button-prev')
        };
      }
      if (navStyle === 'pagination' || navStyle === 'both') {
        var pagEl = el.querySelector(':scope > .swiper-pagination');
        opts.pagination = { el: pagEl, clickable: true };

        if (pagEl && pagEl.dataset.paginationStyle === 'bold') {
          opts.pagination.renderBullet = function (index, className) {
            return (
              '<span class="' + className + ' custom-bullet">' +
              '<svg class="progress-ring" viewBox="0 0 34 34" aria-hidden="true">' +
              '<circle class="progress-ring-bg" cx="17" cy="17" r="16"></circle>' +
              '<circle class="progress-ring-fill" cx="17" cy="17" r="16"></circle>' +
              '</svg>' +
              '<span class="bullet-dot"></span>' +
              '</span>'
            );
          };
        }
      }

      el.swiperInstance = new window.Swiper(el, opts);
    }

    destroyCarousel() {
      var el = this.querySelector('[data-related-swiper]');
      if (el && el.swiperInstance) {
        el.swiperInstance.destroy(true, true);
        el.swiperInstance = null;
      }
    }

    /* No related products: keep the hint in the editor, hide on storefront. */
    handleEmpty() {
      if (window.Shopify && window.Shopify.designMode) return;
      this.hidden = true;
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }


  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector && event.target.querySelector('related-products');
    if (el && el.destroyCarousel) el.destroyCarousel();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector && event.target.querySelector('related-products');
    if (el && el.initCarousel) el.initCarousel();
  });
})();